const acl = require("./config_acl").default;
const router = require("./routes").default;
const ecosystem = require("../ecosystem").default;
const api_url = ecosystem[process.env.MODE].API_HOST;
const SOCKET_HOST = ecosystem[process.env.MODE].SOCKET_HOST;
const web_host = ecosystem[process.env.MODE].WEB_HOST;
const APP = ecosystem[process.env.MODE].APP;
const FOLDER = ecosystem[process.env.MODE].FOLDER;
//NOTA: ver archivo nuxt.js proxy:{}
const proxy_api = "";
console.log(`-- MODE: ${process.env.MODE}  --`, APP.LANG);
console.log(`-- API URL:${api_url} --`);
const config = {
  APP,
  lang: APP.LANG || "en",
  date_format: APP.DATE_FORMAT || "MM/DD/YYYY",
  date_format_hh: APP.DATE_FORMAT_HH || "MM/DD/YYYY HH:mm",
  web_host,
  // Configuración api
  web_key: "e5c7eb43a2d92b7929c55fd5bbabae035318893719f568077c2e0ca801a3d276",
  socket: {
    url: SOCKET_HOST,
    KEYS: {
      /** CONNECTIONS */
      connection: "connection",
      new_user: "add user",
      user_joined: "user joined",
      user_left: "user left",
      disconnect: "disconnect",
      room: "room",
      login: "login",
      /** CITAS */
      available_docs: "available_docs",
      show_doc: "show_doc",
      cancel_show_doc: "cancel_show_doc",
      accept_doc: "accept_doc",
      refreshPage: "refresh_page",
    },
  },
  api_url,
  api_mesites: {
    url: "http://192.168.30.17/ejecutar-regla-json.aspx?regla=",
  },

  api_no_proxy: {
    url: api_url,
    archivos: api_url + "archivos/",
    plantillas: api_url + "plantillas/",
    plantillas_archivos: api_url + "plantillas_editor/",
    plantillas_archivos_pdf: api_url + "plantillas_editor_pdf/",
    plantillas_archivos_inicio: api_url + "plantillas_editor_inicio/",
    new_template: api_url + "new_template/",
    vista: api_url + "plantillas/archivo/",
    reportes: api_url + "reportes/",
    wf: api_url + "flujo/",
    paradocs: api_url + "paradocs/",
    paracodes: api_url + "paracodes/",
    landing: api_url + "landing/",
    archivos_paracodes:
      api_url + "reportmasters/js/paracodes/paracodes/maestros/",
    archivos_pdf:
      "http://crdpruebas.eastus.cloudapp.azure.com:5002/ejecutar?regla=generarpdf",
  },
  api: {
    url: proxy_api,
    archivos: proxy_api + "archivos/",
    plantillas: proxy_api + "plantillas/",
    plantillas_archivos: proxy_api + "plantillas_editor/",
    plantillas_archivos_pdf: proxy_api + "plantillas_editor_pdf/",
    plantillas_archivos_inicio: proxy_api + "plantillas_editor_inicio/",
    vista: proxy_api + "plantillas/archivo/",
    reportes: proxy_api + "reportes/",
    wf: proxy_api + "flujo/",
    paradocs: proxy_api + "paradocs/",
    paracodes: proxy_api + "paracodes/",
    pathTareas: "flujo/tareas/",
  },
  // ---- Configuración del acl
  roles: acl.roles,
  targets: acl.targets,
  actions: acl.actions,
  router,
  INDICATIVO_FORMS: "form_",
  payroll_links: {
    docplaces: ["746d983f-4b21-4b19-9885-c2676066e796"],
    status_url: "http://l3af-payroll.llego.co/api/user-status",
    pdf_url: "http://l3af-payroll.llego.co/api/pdf",
    xml_url: "http://l3af-payroll.llego.co/api/xml",
  },
  wf_casos: {
    tipos: {
      PRIVADO: "RADICACION_INTERNA",
      PUBLICO: "RADICACION_PUBLICA",
      AUTOMATICA: "RADICACION_AUTOMATICA",
    },
  },
  states: {
    UNASSIGNED: "UNASSIGNED",
    ACCEPTED: "ACCEPTED",
    REJECTED: "REJECTED",
    PENDING: "PENDING",
    BLOCKED: "BLOCKED",
    INCONSISTENCY: "INCONSISTENCY",
    CLOSED: "CLOSED",
    SUCCESS: "SUCCESS",
  },
  substates: {
        DEFAULT: "IN_PROGRESS",
        IN_PROGRESS: "IN_PROGRESS",
        NOT_INITIALIZED: "NOT_INITIALIZED",
        COMPLETED: "COMPLETED",
        CLOSED: "CLOSED",
      },
  substates_config: {
        IN_PROGRESS: {
          id: "IN_PROGRESS",
          name: "EN PROCESO",
          name_en: "IN PROGRESS",
          color: "orange",
        },
        NOT_INITIALIZED: {
          id: "NOT_INITIALIZED",
          name: "SIN ASIGNAR",
          name_en: "NOT ASSIGNED",
          color: "blue",
          icon: "block",
        },

        COMPLETED: {
          id: "COMPLETED",
          name: "COMPLETADO",
          name_en: "COMPLETED",
          color: "green",
        },
        CLOSED: {
          id: "CLOSED",
          name: "CERRADO",
          name_en: "CLOSED",
          color: "red",
        },
      },
  states_config: {
    UNASSIGNED: {
      id: "UNASSIGNED",
      name: "SIN ASIGNAR",
      name_en: "NOT ASSIGNED",
      color: "blue",
      icon: "block",
    },
    PENDING: {
      id: "PENDING",
      name: "PENDIENTE",
      name_en: "PENDING",
      color: "orange",
      icon: "hourglass_bottom",
    },
    SUCCESS: {
      id: "SUCCESS",
      name: "COMPLETADO",
      name_en: "COMPLETED",
      color: "green",
      icon: "done",
      uid: "-5",
    },
    ACCEPTED: {
      id: "ACCEPTED",
      name: "ACEPTADO",
      name_en: "ACCEPTED",
      color: "green",
      icon: "done",
    },
    REJECTED: {
      id: "REJECTED",
      name: "RECHAZADO",
      name_en: "MISSING INFO",
      color: "brown",
      icon: "close",
    },
    BLOCKED: {
      id: "BLOCKED",
      name: "BLOQUEADO",
      name_en: "BLOCKED",
      color: "red",
      icon: "block",
    },
    INCONSISTENCY: {
      id: "INCONSISTENCY",
      name: "INCONSISTENCIA",
      name_en: "INCONSISTENCY",
      color: "red",
    },
    CLOSED: {
      id: "CLOSED",
      name: "CERRADO",
      name_en: "CLOSED",
      color: "red",
      uid: "-4",
    },
  },
  cookie: {
    applicationTemporal: "aplicationTemporal",
    userid: "userid",
    lastprotocol: "lastprotocol",
    projectmagisteruid: "projectmagisteruid",
    projectmagistername: "projectmagistername",
    useruid: "useruid",
    userid: "userid",
    username: "username",
    timezone: "timezone",
    entity: "entity",
    token: "token",
    roles: "roles",
    projectid: "projectid",
    teamid: "teamid",
    caseid: "caseid",
    taskid: "taskid",
    loged: "loged",
    projectBuilderUid: "projectBuilderUid",
    projectFiduciaryUid: "projectFiduciaryUid",
    protocolid: "protocolid",
    typeHistoryId: "formUid",
    plantillaCorreoUid: "plantillacorreouid",
    plantillaDocid: "plantilladocid",
    plantillaPDFUid:"plantillapdfuid",
    plantillaInicioUid:"plantillainiciouid",
    pv_id: "pv_id",
    pv_nombre: "pv_nombre",
    filters_cases: "filters_cases",
    filters_cases_data: "filters_cases_data",
  },
  store: {
    user: "user",
    pendingTasks: "pendingTasks",
    plantilla: "plantilla",
    protocolo: "protocolo",
    caso: "caso",
    cargarBorrador: "cargarBorrador",
  },

  expressions: {
    email: /^(?:[^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*|"[^\n"]+")@(?:[^<>()[\].,;:\s@"]+\.)+[^<>()[\]\.,;:\s@"]{2,63}$/i,
    password: /^([a-zA-Z0-9_-]){8,16}$/,
    cellphone: /^[0-9]{3}[0-9]{7}$/,
  },
  estadoUsuarios: {
    inactivo: "inactivo",
  },
  pathDiscoArchivos: `util/${FOLDER}/disco_utilizado_archivos/0`,
  pathDiscoDB: `util/${FOLDER}/disco_utilizado_db/`,
  pathTareas: "flujo/tareas/",
  maestrosExtra: [
    {
      category: "administracion",
      plural: "Funciones",
      path: "/main/funciones",
    },
  ],
};

export default config;
